
<div class="h-100" *ngIf="(geopointsService.nombreComponente == 'LISTAR')">
  <app-list-geopoints></app-list-geopoints>
</div>

<div class="h-100" *ngIf="(geopointsService.nombreComponente == 'AGREGAR')">
  <app-add-geopoints></app-add-geopoints>
</div>
